import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import i18n from "i18n";
import settings from "configs/settings";

type environments = "dev" | "test" | string; // cannot give type for env parameter;
const runEnv: environments = process.env.REACT_APP_ENV || "test";

export const environmentsBaseUrl = {
  dev: settings.baseUrlDevServer,
  test: settings.baseUrlTestServer,
  prod: settings.baseUrlProd,
};

export const baseUrl: string = environmentsBaseUrl[runEnv];

const baseQuery: any = fetchBaseQuery({
  baseUrl: environmentsBaseUrl[runEnv],
  // baseUrl: settings.baseUrlTestServer,
  // Required so the browser stores the Set-Cookie ("token") from verifyOtp and
  // sends it on subsequent authenticated requests. The cookie is HttpOnly +
  // Secure + SameSite=None, so this also requires the API be reached over HTTPS
  // and the server to send CORS Access-Control-Allow-Credentials: true.
  credentials: "include",
});
let isRedirected = false;
export const baseQueryWithReauth = async (args, api, extraOptions) => {
  try {
    const result = await baseQuery(args, api, extraOptions);
    const responseStatus = result?.meta?.response?.status;
    if (responseStatus === 401 && window.location.pathname === "/login")
      localStorage.clear();
    else if (
      responseStatus === 401 &&
      window.location.pathname !== "/login" &&
      !isRedirected
    ) {
      localStorage.clear();
      isRedirected = true;
      window.location.href = "/";
      alert(i18n.t("logInAgain"));

      // logout api when ready
      //     baseQuery.api.dispatch(logOut(api.getState()));
    }

    return result;
  } catch (error) {
    console.error("error", error);
    return { error: error?.message };
  }
};

export const apiSliceDev = createApi({
  reducerPath: "devApiReducer",
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
